import React from 'react';
import { Kpi } from '../types';
import { ArrowUpIcon, ArrowDownIcon } from './icons';

interface KpiCardProps extends Kpi {
    onClick?: () => void;
}

const KpiCard: React.FC<KpiCardProps> = ({ title, value, change, changeType, onClick }) => {
  const isIncrease = changeType === 'increase';
  const changeColor = isIncrease ? 'text-secondary' : 'text-red-500';
  
  const colorMap: { [key: string]: string } = {
    'Ingresos': 'bg-secondary',
    'Gastos': 'bg-accent-rose',
    'Beneficio': 'bg-accent-amber',
    'Margen': 'bg-accent-violet',
    'Valor/Hora': 'bg-primary'
  };

  return (
    <div 
        className={`relative overflow-hidden bg-light-surface dark:bg-surface p-5 rounded-lg border border-light-border dark:border-border shadow-md transition-transform ${onClick ? 'hover:scale-105 cursor-pointer' : ''}`}
        onClick={onClick}
    >
      <h4 className="text-sm font-medium text-light-text-secondary dark:text-text-secondary">{title}</h4>
      <p className="text-3xl font-bold text-light-text-primary dark:text-text-primary mt-2">{value}</p>
      {change && (
        <div className={`flex items-center mt-2 text-sm ${changeColor}`}>
          {isIncrease ? <ArrowUpIcon className="w-4 h-4" /> : <ArrowDownIcon className="w-4 h-4" />}
          <span className="ml-1 font-semibold">{change}</span>
          <span className="text-light-text-secondary dark:text-text-secondary ml-1">vs mes anterior</span>
        </div>
      )}
      <div className={`absolute bottom-0 left-0 w-full h-1.5 ${colorMap[title] || 'bg-gray-400'}`}></div>
    </div>
  );
};

export default KpiCard;